export default function Spinner({ size = "md", label = "" }) {
  const dim = { sm: "w-5 h-5", md: "w-8 h-8", lg: "w-12 h-12" }[size] ?? "w-8 h-8";
  const border = { sm: "border-2", md: "border-[3px]", lg: "border-4" }[size] ?? "border-[3px]";

  return (
    <span className="inline-flex flex-col items-center gap-3" role="status" aria-label={label || "Loading"}>
      <span
        className={`${dim} ${border} rounded-full border-indigo-500 border-t-transparent animate-spin`}
      />
      {label && <span className="text-sm text-[#555]">{label}</span>}
    </span>
  );
}
